/**
 * Présentation d'un score d'essai (carte du Feed + page de résultats) : teinte,
 * appréciation courte, barres par question. Pur (testé).
 */

export interface ScoreTone {
  /** Texte du pourcentage. */
  text: string;
  /** Anneau / bordure. */
  ring: string;
  /** Fond doux (pastille). */
  soft: string;
}

export function scoreTone(score: number | null): ScoreTone {
  if (score === null) {
    return { text: 'text-ink-500', ring: 'border-ink-200', soft: 'bg-ink-50 ocean:bg-white/5' };
  }
  if (score >= 80) {
    return {
      text: 'text-green-600 ocean:text-green-300',
      ring: 'border-green-400',
      soft: 'bg-green-50 ocean:bg-green-500/15',
    };
  }
  if (score >= 50) {
    return {
      text: 'text-amber-600 ocean:text-amber-300',
      ring: 'border-amber-400',
      soft: 'bg-amber-50 ocean:bg-amber-500/15',
    };
  }
  return {
    text: 'text-red-500 ocean:text-red-400',
    ring: 'border-red-400',
    soft: 'bg-red-50 ocean:bg-red-500/15',
  };
}

/** Appréciation courte du score (vide sans score). */
export function scoreAppreciation(score: number | null): string {
  if (score === null) return '';
  if (score >= 90) return 'Excellent ! 🎉';
  if (score >= 70) return 'Bien joué 💪';
  if (score >= 50) return 'Pas mal, continue 👍';
  return 'À retravailler 🔁';
}

/** Couleur d'une barre de question : juste / faux / non corrigée. */
export function stepBarClass(wasCorrect: boolean | null | undefined): string {
  if (wasCorrect === true) return 'bg-green-400';
  if (wasCorrect === false) return 'bg-red-400';
  return 'bg-ink-200 ocean:bg-white/15';
}
